module.exports = __webpack_public_path__ + "static/media/cta_laraki.9d7f1df3.svg";